var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"footerBar"},[_c('div',[_c('strong',[_vm._v("Atelier 2")]),_vm._v(" Geoquizz - Cisiie.")]),_vm._v(" "),_c('div',[_vm._v("Yann Dumas - Nicolas Bobelet - Mohamed Alhasne - Daniel Ricklin - Alexandra Martin")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-704249d3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Footer.vue
// module id = null
// module chunks = 